module.exports = __webpack_public_path__ + "static/media/fps-10-4@2x.93100ce1.png";